import imageCompression from 'browser-image-compression';

interface CompressionOptions {
  maxSizeMB?: number;
  maxWidthOrHeight?: number;
  useWebWorker?: boolean;
}

/**
 * Comprime e redimensiona uma imagem para reduzir seu tamanho
 * @param file Arquivo de imagem original
 * @param options Opções de compressão
 * @returns Promise com o arquivo comprimido
 */
export const compressImage = async (
  file: File,
  options: CompressionOptions = {}
): Promise<File> => {
  const {
    maxSizeMB = 2, // 2MB padrão
    maxWidthOrHeight = 1920, // Máximo de largura ou altura
    useWebWorker = true,
  } = options;

  try {
    const compressedFile = await imageCompression(file, {
      maxSizeMB,
      maxWidthOrHeight,
      useWebWorker,
      fileType: 'image/jpeg',
      initialQuality: 0.8,
    });

    return compressedFile;
  } catch (error) {
    console.error('Erro ao comprimir imagem:', error);
    // Se houver erro, retorna o arquivo original
    return file;
  }
};

/**
 * Verifica se uma imagem precisa ser comprimida
 * @param file Arquivo de imagem
 * @param maxSizeMB Tamanho máximo em MB
 * @returns true se a imagem precisa ser comprimida
 */
export const needsCompression = (file: File, maxSizeMB: number = 2): boolean => {
  const fileSizeMB = file.size / (1024 * 1024);
  return fileSizeMB > maxSizeMB;
};

/**
 * Obtém as dimensões de uma imagem
 * @param file Arquivo de imagem
 * @returns Promise com largura e altura
 */
export const getImageDimensions = (file: File): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: img.width, height: img.height });
    };
    
    img.onerror = (error) => {
      URL.revokeObjectURL(url);
      reject(error);
    };
    
    img.src = url;
  });
};

